import { Star } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { useAuthStore } from '@/entities/session/model/authStore';
import { useMetadataStore } from '@/entities/metadata/model/metadataStore';

export function FavoriteStar({ screenId, favorite }: { screenId: string; favorite: boolean }) {
  const userId = useAuthStore((s) => s.user?.userId);
  const toggle = useMetadataStore((s) => s.toggleFavorite);
  return (
    <button
      type="button"
      aria-label={favorite ? 'Favorilerden çıkar' : 'Favorilere ekle'}
      aria-pressed={favorite}
      onClick={(e) => {
        e.stopPropagation();
        if (userId) void toggle(userId, screenId);
      }}
      className={cn(
        'text-fg-subtle rounded p-0.5 opacity-0 transition-opacity group-hover:opacity-100 focus-visible:opacity-100',
        favorite && 'text-warning opacity-100',
      )}
    >
      <Star className={cn('h-3.5 w-3.5', favorite && 'fill-current')} />
    </button>
  );
}
